import { Filters } from "@shopify/polaris"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const useDebounce = (value, delay) => {
	const [debouncedValue, setDebouncedValue] = useState(value)

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value)
		}, delay)

		return () => {
			clearTimeout(handler)
		}
	}, [value, delay])

	return debouncedValue
}

export const ProductsSelectorFilter = ({ setQuery }) => {
	const [_query, _setQuery] = useState("")
	const debouncedQuery = useDebounce(_query, 300)
	const { t } = useTranslation()

	useEffect(() => {
		setQuery(debouncedQuery)
	}, [debouncedQuery])

	return (
		<Filters
			queryPlaceholder={t(
				"multiple.filter_products_by_title_or_price_unrounded",
			)}
			filters={[]}
			queryValue={_query}
			onQueryChange={(change) => _setQuery(change)}
			onQueryClear={() => _setQuery("")}
		/>
	)
}
